import { InventoryEffect } from '../inventory/inventory.model';

export type NarratorId = string;

export type NarratorNPC = {
  id: NarratorId;
  name: string;
  dialog: Dialog[];
};

export const DIALOG_START_ID = 'start';

export type DialogId = string | typeof DIALOG_START_ID;

export type Dialog = {
  id: DialogId;
  text: string;
  name?: string;
  options?: DialogOption[];
  type?: DialogType;
  effects?: InventoryEffect[];
  // When true, entering this node opens the merchant sell/buy panel.
  openMerchant?: boolean;
};

export type DialogOption = {
  text: string;
  nextDialogId: DialogId | (() => DialogId);
  condition?: () => boolean;
  // When set, selecting this option shows a loading animation for `delayMs`
  // milliseconds before navigating to `nextDialogId`. `loadingText` is the base
  // text shown while waiting (animated dots are appended).
  delayMs?: number;
  loadingText?: string;
};

export enum DialogType {
  dialog = 'dialog',
  description = 'description',
}

export enum NarratorEventBus {
  narratorStart = 'narratorStart', // still allow navigation with smaller starting narrator
  dialogStart = 'dialogStart', // disables navigation with bigger narrator
  nodeEntered = 'nodeEntered', // fired when a Dialog node carrying an effect is entered
}

export type NodeEnteredPayload = { effects: InventoryEffect[] };
